module.exports = __webpack_public_path__ + "img/playstore.c3de1233.png";